import { BasePopup } from "./nineDialog.js";

export class nineConfirmPopup extends BasePopup {
	static tagName = 'nine-confirm-popup';

	constructor() {
		super();
	}


	render(message, config) {
		this.shadowRoot.innerHTML = `
            <nine-dialog>
                <div class="msg">${message.replace(/\n/g, "<br/>")}</div>
                <div class="buttons-confirm">
                    <button class="cancel">${config["false-text"]}</button>
                    <button class="ok">${config["true-text"]}</button>
                </div>
            </nine-dialog>`;
	}

	setupEvents(resolve, dialogComp) {
		this.shadowRoot.querySelector(".ok").onclick = () => dialogComp.closeWithAnimation(true);
		// 취소는 nine-dialog 내부 기본 로직(closeWithAnimation(null))이 처리함
	}

	static confirm = (m, t, o) => BasePopup.open(nineConfirmPopup, m, t, o, (el, msg, conf) => el.render(msg, conf));
}

// --- 3. ALERT (단순 알림) ---
export class nineAlertPopup extends BasePopup {
	static tagName = 'nine-alert-popup';

	constructor() {
		super();
	}

	render(message, config) {
		this.shadowRoot.innerHTML = `
            <nine-dialog>
                <div class="msg">${message.replace(/\n/g, "<br/>")}</div>
                <div class="buttons-confirm">
                    <button class="cancel">확인</button>
                </div>
            </nine-dialog>`;
	}

	setupEvents(resolve, dialogComp) {
		// 얼럿은 취소 버튼 하나만 두거나, 확인 버튼이 cancel 역할을 수행하게 함
	}

	static alert = (m, t, o) => BasePopup.open(nineAlertPopup, m, t, o, (el, msg, conf) => el.render(msg, conf));
}

// Custom Element 등록
if (!customElements.get('nine-confirm-popup')) customElements.define('nine-confirm-popup', nineConfirmPopup);
if (!customElements.get('nine-alert-popup')) customElements.define("nine-alert-popup", nineAlertPopup);